import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef } from 'react';
import { describe } from '@amzn/stencil-react-desc';
import { Button, ButtonVariant } from "../../button";
import { BORDER_WIDTH, OUTLINE_OFFSET } from "../../button/constants";
import { styledWithTheme } from "../../context";
import { pick, px, withTestAttributes } from "../../utils";
import { PageHeaderButton } from "./";
import { jsx as ___EmotionJSX } from "@emotion/core";
var PageHeaderDropdownButtonBase = styledWithTheme(Button)(function (_ref) {
  var selectors = _ref.theme.selectors;
  return {
    backgroundColor: 'transparent',
    borderRadius: '0',
    padding: '16px 24px',
    height: '100%',
    width: '100%',
    fontWeight: selectors.fontWeight('regular'),
    justifyContent: 'flex-start',
    transition: 'none',
    ':hover': {
      backgroundColor: selectors.color('primary05'),
      textDecoration: 'none'
    },
    ':focus:before': {
      border: 'none',
      borderRadius: '0',
      inset: 0,
      transition: 'none',
      zIndex: selectors.zIndex('highest'),
      outline: "".concat(px(BORDER_WIDTH), " solid transparent"),
      outlineOffset: OUTLINE_OFFSET
    }
  };
});
var PageHeaderDropdownButtonWithoutDocs = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
      forwardedProps = _objectWithoutProperties(_ref2, _excluded);

  return ___EmotionJSX(PageHeaderDropdownButtonBase, _extends({
    shouldUseResponsiveContent: false,
    variant: ButtonVariant.Tertiary
  }, forwardedProps, {
    ref: ref
  }), children);
});
var PageHeaderDropdownButtonWithDocs = describe(PageHeaderDropdownButtonWithoutDocs).description('Button dropdown item for PageHeader.');
PageHeaderDropdownButtonWithDocs.propTypes = _objectSpread(_objectSpread({}, Button.describedPropTypes), pick(PageHeaderButton.describedPropTypes, ['children', 'icon']));
export var PageHeaderDropdownButton = withTestAttributes({
  component: 'StencilReactPageHeaderDropdownButton'
})(PageHeaderDropdownButtonWithDocs);
PageHeaderDropdownButton.displayName = 'PageHeaderDropdownButton';